import { APIUtils } from './APIUtils';

const getPlusOneByMonth = async (beginYear, beginMonth, endYear, endMonth) => {
    return APIUtils.get(`/api/getNotesByMonth?beginYear=${beginYear}&beginMonth=${beginMonth}&endYear=${endYear}&endMonth=${endMonth}`);
}

export {
    getPlusOneByMonth
}
